/**
 * Created by neo on 26.02.17.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { Container } from 'reactstrap';
import ImageGallery from 'react-image-gallery';
import CloseButton from '../CloseButton';

type Props = {
  medias: Array<any>,
  open?: boolean,
  onClose: () => void,
};

@observer
export default class MediaGallery extends React.Component<Props, void> {
  render() {
    const { props: { open, medias, onClose } } = this;
    const images = medias.filter(m => m.mime_type.startsWith('image'));
    const items = images.map(m => {
      return { original: m.url, thumbnail: m.url };
    });

    return (
      <div className="gallery-container" style={{ display: open ? 'block' : 'none' }}>
        <div className="close-button-container">
          <CloseButton onClick={onClose} />
        </div>
        <div className="gallery" style={{ display: open ? 'flex' : 'none' }}>
          <Container>
            <ImageGallery items={items} slideInterval={2000} />
          </Container>
        </div>
        <div
          className="gallery-backdrop"
          style={{ display: open ? 'block' : 'none' }}
          onClick={onClose}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/GalleryHeader/MediaGallery.js